import { apiClient } from './api-client';
import type { AccountProfile, UpdateProfileInput, ChangePasswordInput } from '../types/account';

export async function fetchAccountProfile(): Promise<AccountProfile> {
  return apiClient<AccountProfile>('/auth/me');
}

export async function updateAccountProfile(
  input: UpdateProfileInput
): Promise<AccountProfile> {
  return apiClient<AccountProfile>('/admin/account/profile', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

/**
 * Change password via raw fetch to avoid apiClient's 401 auto-logout.
 * The backend returns 401 for wrong current password, which apiClient
 * would interpret as an expired session.
 */
export async function changePassword(input: ChangePasswordInput): Promise<void> {
  const apiOrigin = import.meta.env.VITE_API_URL || '';
  const token = localStorage.getItem('access_token');

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  // Read CSRF token from cookie
  for (const cookie of document.cookie.split(';')) {
    const [name, ...parts] = cookie.split('=');
    if (name?.trim() === 'quiz-commerce.x-csrf-token') {
      headers['X-CSRF-Token'] = decodeURIComponent(parts.join('=').trim());
      break;
    }
  }

  const response = await fetch(`${apiOrigin}/api/v1/auth/change-password`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Aktuelles Passwort ist falsch.');
    }
    const body = await response.json().catch(() => ({})) as Record<string, unknown>;
    throw new Error(
      (body.message as string) || (body.error as string) || 'Passwort ändern fehlgeschlagen.'
    );
  }
}
